import { Point } from '@/types';
import { getClosestPointOnAngleLine } from './getClosestPointOnLine';
import { getVectorLength } from './getVectorLength';
import { isAngleLine, isHorizontalLine, isVerticalLine } from './isLineType';
import { round } from './round';
import { subtractVectors } from './subtractVectors';
import { Line } from './types';

const nullVector = { x: 0, y: 0 };
export const getDistanceFromParallelLines = (line1: Line, line2: Line): [number, Point] => {
  if (isHorizontalLine(line1) && isHorizontalLine(line2)) {
    const difference = line1.y - line2.y;
    return [Math.abs(difference), { x: 0, y: difference }];
  }

  if (isVerticalLine(line1) && isVerticalLine(line2)) {
    const difference = line1.x - line2.x;
    return [Math.abs(difference), { x: difference, y: 0 }];
  }

  if (isAngleLine(line1) && isAngleLine(line2) && round(line1.m) === round(line2.m)) {
    const pointOnLine2 = { x: 0, y: line2.b };
    const closestPointOnLine = getClosestPointOnAngleLine(line1, pointOnLine2);
    const snapDifference = subtractVectors(closestPointOnLine, pointOnLine2);
    return [getVectorLength(snapDifference), snapDifference];
  }

  return [Number.POSITIVE_INFINITY, nullVector];
};
